<div class="container">
  <div class="logo">
    <img src="./assets/images/transend.png">
  </div>

  <div class="nav-item" *ngFor="let menu of menus; let i = index">
    <!-- Menu item with children (expandable) -->
    <ng-container *ngIf="menu.children && menu.children.length > 0; else singleMenuItem">
      <div class="expandable-group" [class]="'group-' + i">
        <div class="nav-links expandable" (click)="toggleMenu(menu)">
          <div class="nav-icon" [class.nav-icon-active]="isMenuActive(menu)">
            <mat-icon>{{ menu.icon }}</mat-icon>
          </div>

          <div class="nav-title-container">
            <span class="nav-title" [class.nav-title-active]="isMenuActive(menu)">
              {{ menu.url.replace('-', ' ') }}
              <mat-icon class="expand-icon" [class.expanded]="menu.expanded">
                keyboard_arrow_down
              </mat-icon>
            </span>
          </div>
        </div>

        <!-- Children items -->
        <div class="children-container" [class.expanded]="menu.expanded" *ngIf="menu.children">
          <div class="child-nav-item" *ngFor="let child of menu.children">
            <div class="nav-links">
              <a [routerLink]="child.url" [routerLinkActive]="'nav-icon-active'" class="nav-icon child-icon">
                <mat-icon>{{ child.icon }}</mat-icon>
              </a>

              <a [routerLink]="child.url" [routerLinkActive]="['nav-title-active']" class="nav-title">
                {{ child.url.replace('-', ' ') }}
              </a>
            </div>

            <div [class.active-tab]="this.currentUrl === child.url"></div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Single menu item template -->
    <ng-template #singleMenuItem>
      <div class="nav-links">
        <a [routerLink]="menu.url" [routerLinkActive]="'nav-icon-active'" class="nav-icon">
          <mat-icon>{{ menu.icon }}</mat-icon>
        </a>

        <a [routerLink]="menu.url" [routerLinkActive]="['nav-title-active']" class="nav-title">
          {{ menu.url.replace('-', ' ') }}
        </a>
      </div>

      <div [class.active-tab]="this.currentUrl === menu.url"></div>
    </ng-template>
  </div>
</div>